module.exports = __webpack_public_path__ + "assets/img/B-df3ce596.jpg";